import { useState } from 'react';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../Dialog';

interface Props {
  isShow: boolean;
  onHide: () => void;
  onAcknowledge: (dismissForever: boolean) => void;
}

const ParentalConsentWarningModal = ({ isShow, onHide, onAcknowledge }: Props) => {
  const [dismissForever, setDismissForever] = useState(false);

  return (
    <Dialog
      open={isShow}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onHide();
        }
      }}
    >
      <DialogContent
        className='w-[min(95vw,560px)] rounded-[0.6rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_14px_34px_rgba(0,0,0,0.2)]'
        overlayClassName='bg-black/50'
      >
        <DialogHeader className='relative mb-0 items-center px-[2.6rem] pb-[1rem] pt-[2.2rem]'>
          <button
            type='button'
            onClick={onHide}
            aria-label='Close'
            className='absolute right-[1rem] top-[0.7rem] inline-flex h-[2.8rem] w-[2.8rem] items-center justify-center rounded-full border-0 bg-transparent p-0 text-[2.4rem] leading-none text-[#242424] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#242424]/40'
          >
            x
          </button>
          <DialogTitle asChild>
            <h3 className='m-0 text-center text-[#242424]'>Student account permissions</h3>
          </DialogTitle>
        </DialogHeader>

        <DialogBody
          className="px-[2.6rem] pb-[0.8rem] text-center font-['GT-Walsheim-Pro-Light'] text-[1.6rem] leading-[1.5] text-[#3f3f3f]"
          id='dialogBody'
        >
          By clicking 'I agree', you are indicating that you have the necessary parental consent, or are consenting on
          parents' behalf, to use student accounts for this class. This program is provided by your school.
        </DialogBody>

        <DialogFooter className='mt-0 flex-col items-center gap-[1.2rem] px-[2.6rem] pb-[2.2rem] pt-[0.8rem]'>
          <PrimaryButton type='button' onClick={myOnAcknowledge}>
            I Agree
          </PrimaryButton>
          <label className='flex cursor-pointer items-center justify-center gap-[1rem] text-[1.2rem] leading-none text-[#3f3f3f]'>
            <input
              type='checkbox'
              checked={dismissForever}
              onChange={() => setDismissForever(!dismissForever)}
              className='m-0 h-[1.4rem] w-[1.4rem] cursor-pointer'
            />
            <span>Do not ask this question again</span>
          </label>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );

  function myOnAcknowledge() {
    onAcknowledge(dismissForever);
  }
};

export default ParentalConsentWarningModal;
